import { FC } from "react";

import { Box } from "@chakra-ui/react";
import { Formik } from "formik";
import { useTranslation } from "next-i18next";

import Icon from "@components/Icon";
import Message from "@components/Message";

import useForgotPassword from "../hooks/useForgotPassword";
import { getForgotPasswordValidationSchema } from "../utils/validations";
import ForgotPasswordFormFields from "./ForgotPasswordFormFields";

const initialValues = { email: "" };
const PasswordRecoveryForm: FC = () => {
  const { t } = useTranslation();
  const { handleSubmit, isLoading, errors, hasSucceeded } = useForgotPassword();

  if (hasSucceeded) {
    return (
      <Message variant="success" icon={<Icon icon="success" size="1.75rem" />}>
        {t("password_recovery-errors-successful_password_recovery")}
      </Message>
    );
  }

  return (
    <Box pb="3.25rem" pt="0.5rem">
      <Formik
        validateOnBlur
        validationSchema={getForgotPasswordValidationSchema(t)}
        onSubmit={handleSubmit}
        initialValues={initialValues}
      >
        {() => <ForgotPasswordFormFields isLoading={isLoading} errors={errors} />}
      </Formik>
    </Box>
  );
};

export default PasswordRecoveryForm;
